import { render, staticRenderFns } from "./AdserverInspector.vue?vue&type=template&id=4bd20b20&"
import script from "./AdserverInspector.vue?vue&type=script&lang=ts&"
export * from "./AdserverInspector.vue?vue&type=script&lang=ts&"
import style0 from "./AdserverInspector.vue?vue&type=style&index=0&id=4bd20b20&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports